export default __webpack_public_path__ + "static/media/check-circle-all-ok.3e71eb21.svg";